import React, { useEffect, useRef } from 'react';

import { rAFTimeout } from '../../../utils/utils';
import Layout from './Layout';

import * as styles from './Loader.module.scss';

export type LoaderAnimationState = 'pending' | 'animatingIn' | 'animatingOut';

interface LoaderProps {
  animationState: LoaderAnimationState;
}

const Loader = ({ animationState }: LoaderProps): React.ReactElement => {
  const circleRef = useRef<HTMLDivElement>(null);
  const ray1Ref = useRef<HTMLDivElement>(null);
  const ray2Ref = useRef<HTMLDivElement>(null);
  const ray3Ref = useRef<HTMLDivElement>(null);
  const ray4Ref = useRef<HTMLDivElement>(null);
  const ray5Ref = useRef<HTMLDivElement>(null);
  const ray6Ref = useRef<HTMLDivElement>(null);
  const ray7Ref = useRef<HTMLDivElement>(null);
  const ray8Ref = useRef<HTMLDivElement>(null);
  const raysRefs = [ray1Ref, ray2Ref, ray3Ref, ray4Ref, ray5Ref, ray6Ref, ray7Ref, ray8Ref];

  useEffect(() => {
    if (animationState === 'animatingIn') {
      rAFTimeout(() => circleRef.current && circleRef.current.classList.add(styles.animateIn), 150);

      rAFTimeout(() => {
        raysRefs.forEach((rayRef, index) => {
          rAFTimeout(
            () => rayRef.current && rayRef.current.classList.add(styles.animateIn),
            index * 80,
          );
        });
      }, 300);

      rAFTimeout(() => {
        rAFTimeout(
          () => circleRef.current && circleRef.current.classList.add(styles.startRotation),
          300,
        );
      }, 500);
    }
    if (animationState === 'animatingOut') {
      rAFTimeout(
        () => circleRef.current && circleRef.current.classList.add(styles.animateOut),
        550,
      );

      raysRefs.forEach((rayRef, index) => {
        rAFTimeout(
          () => rayRef.current && rayRef.current.classList.add(styles.animateOut),
          index * 50,
        );
      });
    }
  }, [animationState]);

  return (
    <Layout>
      <div className={styles.loader}>
        <div ref={circleRef} className={styles.loaderCircle}>
          <div className={styles.rays}>
            <div ref={ray1Ref} className={styles.ray + ' ' + styles.rayNorth}></div>
            <div ref={ray2Ref} className={styles.ray + ' ' + styles.rayWest}></div>
            <div ref={ray3Ref} className={styles.ray + ' ' + styles.raySouth}></div>
            <div ref={ray4Ref} className={styles.ray + ' ' + styles.rayEast}></div>
          </div>
          <div className={styles.rays}>
            <div ref={ray5Ref} className={styles.ray + ' ' + styles.rayNorth}></div>
            <div ref={ray6Ref} className={styles.ray + ' ' + styles.rayWest}></div>
            <div ref={ray7Ref} className={styles.ray + ' ' + styles.raySouth}></div>
            <div ref={ray8Ref} className={styles.ray + ' ' + styles.rayEast}></div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Loader;
